import "entry/common";

// Still need jquery for the ajax stuff below 😬
import $ from "jquery";

// Workaround a font issue on Chrome/Windows.
import "lib/chrome_fonts";

// Polyfill for HTML5 placeholder
import "jquery-placeholder";

// these are dependencies of draggable/droppable
// probably not in the correct place, but it works
// well enough
import "jquery-ui/ui/core";
import "jquery-ui/ui/widget";
import "jquery-ui/ui/widgets/mouse";

// Adds touch support to jquery ui must be required after
// jquery-ui mouse
//
// We also need to inject a jQuery import, because touch-punch
// is unaware of javascript modules
//
// Obviously we want to aim to get rid of nonsense like this :)

// eslint-disable-next-line import/no-webpack-loader-syntax
import "imports-loader?jQuery=jquery!jquery-ui-touch-punch/jquery.ui.touch-punch";

require("domready")(() => {
  // This applies the polyfill to each input with a placeholder
  $("input[placeholder]").placeholder();
});

// these are being called from inside ERB views, so it needs global scope for now
window.TC.BasePage = require("pages/base_page").default;
window.TC.ChooserView = require("views/chooser_view").default;
window.TC.ColumnPage = require("pages/column_page").default;
window.TC.EditPasswordPage = require("pages/edit_password_page").default;
window.TC.EditProfilePage = require("pages/edit_profile_page").default;
window.TC.InfoPage = require("pages/info_page").default;
window.TC.InstitutionPage = require("pages/institution_page").default;
window.TC.NewEventPage = require("pages/new_event_page").default;
window.TC.NewRegistrationPage = require("pages/new_registration_page").default;
window.TC.NewsletterSubscriptionPage = require("pages/newsletter_subscription_page").default;
window.TC.NewsletterSubscriptionShowPage = require("pages/newsletter_subscription_show_page").default;
window.TC.PartnerPage = require("pages/partner_page").default;
window.TC.PodcastsPage = require("pages/podcasts_page").default;
window.TC.PodcastShowPage = require("pages/podcast_show_page").default;
window.TC.ProfileCredentialsPage = require("pages/profile_credentials_page").default;
window.TC.ProfileNewslettersPage = require("pages/profile_newsletters_page").default;
window.TC.ProfilePage = require("pages/profile_page").default;
window.TC.SearchPage = require("pages/search_page").default;
